"use strict";
"use es6";
/**
 * An error thrown when an element was queried at a certain index of an
 * Observable, but no such index or position exists in that sequence.
 *
 * @see {@link elementAt}
 * @see {@link take}
 * @see {@link takeLast}
 *
 * @class ArgumentOutOfRangeError
 */

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArgumentOutOfRangeError = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));

var ArgumentOutOfRangeError =
/*#__PURE__*/
function (_Error) {
  (0, _inherits2.default)(ArgumentOutOfRangeError, _Error);

  function ArgumentOutOfRangeError() {
    var _this;

    (0, _classCallCheck2.default)(this, ArgumentOutOfRangeError);

    var err = _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ArgumentOutOfRangeError).call(this, 'argument out of range'));

    _this.name = err.name = 'ArgumentOutOfRangeError';
    _this.stack = err.stack;
    _this.message = err.message;
    return _this;
  }

  return ArgumentOutOfRangeError;
}((0, _wrapNativeSuper2.default)(Error));

exports.ArgumentOutOfRangeError = ArgumentOutOfRangeError;